(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-grid"] && !Shopify.designMode) return;
  try {
    
  Theme.carousel('.content-grid.carousel .slider');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-overlay-banner-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.icon-outline-button')
  .forEach(trigger => {
      trigger.onclick = function(e) {
          e.preventDefault();
          let target = document.querySelector('main > section + .shopify-section');
          let elementPosition = target.offsetTop - 60;

          window.scrollTo({
              top: elementPosition,
              behavior: "smooth"
          });
      };
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-overlay-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.icon-outline-button')
  .forEach(trigger => {
      trigger.onclick = function(e) {
          e.preventDefault();
          let target = document.querySelector('main > section + .shopify-section');
          let elementPosition = target.offsetTop - 60;

          window.scrollTo({
              top: elementPosition,
              behavior: "smooth"
          });
      };
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    // Navbar Add Class on Scroll
  let lastScrollY = window.pageYOffset || 0;

    function getScrollPosition() {
        const scrollObject = document.querySelector('body');
    const currentScrollY = window.pageYOffset || 0;

        scrollObjectPos = {
      y: currentScrollY
        }

    const delta = currentScrollY - lastScrollY;
    if (Math.abs(delta) > 6) {
      scrollObject.setAttribute('data-scroll-dir', delta > 0 ? 'down' : 'up');
    }

        // If you want to check distance
        if (scrollObjectPos.y < 1) {
            // clear attr
            scrollObject.setAttribute('data-pos', 'top');
        } else if (scrollObjectPos.y < 160) {
            scrollObject.setAttribute('data-pos', '');
        } else {
            scrollObject.setAttribute('data-pos', '160-plus');
        }

    lastScrollY = currentScrollY;
    }
    getScrollPosition();
    window.onscroll = getScrollPosition;


    const hamburger = document.getElementById('hamburger');
    const navOverlay = document.querySelector('#navigation > .overlay');
    const navContainer = document.getElementById('navigation');

    if (navOverlay && hamburger) {
      navOverlay.addEventListener('click', function () {
        hamburger.click();
      });
    }

    // ESC key pressed -> close open full page navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navContainer && navContainer.classList.contains('show')) {
          hamburger.click();
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product-spin"]) return;
  try {
    
jQuery(function($){

    var productViewer = function(element) {
        this.element = element;
        this.handleContainer = this.element.find('.cd-product-viewer-handle');
        this.handleFill = this.handleContainer.children('.fill');
        this.handle = this.handleContainer.children('.handle');
        this.imageWrapper = this.element.find('.product-viewer');
        this.slideShow = this.imageWrapper.children('.product-sprite');
        this.frames = this.element.data('frame');
        //increase this value to increase the friction while dragging on the image - it has to be bigger than zero
        this.friction = this.element.data('friction');
        this.visibleFrame = 0;
        this.loaded = false;
        this.animating = false;
        this.xPosition = 0;
        this.loadFrames();
    }

    productViewer.prototype.loadFrames = function() {
        var self = this,
            imageUrl = this.slideShow.data('image'),
            newImg = $('<img/>');
        this.loading('0.5');
        //you need this to check if the image sprite has been loaded
        newImg.attr('src', imageUrl).on('load', function() {
            $(this).remove();
              self.loaded = true;
          }).each(function(){
              image = this;
            if(image.complete) {
                $(image).trigger('load');
              }
        });
    }

    productViewer.prototype.loading = function(percentage) {
        var self = this;
        transformElement(this.handleFill, 'scaleX('+ percentage +')');
        setTimeout(function(){
            if( self.loaded ){
                //sprite image has been loaded
                self.element.addClass('loaded');
                transformElement(self.handleFill, 'scaleX(1)');
                self.dragImage();
                if(self.handle) self.dragHandle();
            } else {
                //sprite image has not been loaded - increase self.handleFill scale value
                var newPercentage = parseFloat(percentage) + .1;
                if ( newPercentage < 1 ) {
                    self.loading(newPercentage);
                } else {
                    self.loading(parseFloat(percentage));
                }
            }
        }, 500);
    }
    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    productViewer.prototype.dragHandle = function() {
        //implement handle draggability
        var self = this;
        self.handle.on('mousedown vmousedown', function (e) {
            self.handle.addClass('cd-draggable');
            var dragWidth = self.handle.outerWidth(),
                containerOffset = self.handleContainer.offset().left,
                containerWidth = self.handleContainer.outerWidth(),
                minLeft = containerOffset - dragWidth/2,
                maxLeft = containerOffset + containerWidth - dragWidth/2;

            self.xPosition = self.handle.offset().left + dragWidth - e.pageX;

            self.element.on('mousemove vmousemove', function (e) {
                if( !self.animating) {
                    self.animating =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){self.animateDraggedHandle(e, dragWidth, containerOffset, containerWidth, minLeft, maxLeft);}, 100)
                        : requestAnimationFrame(function(){self.animateDraggedHandle(e, dragWidth, containerOffset, containerWidth, minLeft, maxLeft);});
                }
            }).one('mouseup vmouseup', function (e) {
                self.handle.removeClass('cd-draggable');
                self.element.off('mousemove vmousemove');
            });

            e.preventDefault();

        }).on('mouseup vmouseup', function (e) {
            self.handle.removeClass('cd-draggable');
        });
    }

    productViewer.prototype.animateDraggedHandle = function(e, dragWidth, containerOffset, containerWidth, minLeft, maxLeft) {
        var self = this;
        var leftValue = e.pageX + self.xPosition - dragWidth;
        // constrain the draggable element to move inside his container
        if (leftValue < minLeft) {
            leftValue = minLeft;
        } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = Math.ceil( (leftValue + dragWidth / 2 - containerOffset) * 1000 / containerWidth)/10;
        self.visibleFrame = Math.ceil( (widthValue * (self.frames-1))/100 );

        //update image frame
        self.updateFrame();
        //update handle position
        $('.cd-draggable', self.handleContainer).css('left', widthValue + '%').one('mouseup vmouseup', function () {
            $(this).removeClass('cd-draggable');
        });

        self.animating = false;
    }

    productViewer.prototype.dragImage = function() {
        //implement image draggability
        var self = this;
        self.slideShow.on('mousedown vmousedown', function (e) {
            self.slideShow.addClass('cd-draggable');
            var containerOffset = self.imageWrapper.offset().left,
                containerWidth = self.imageWrapper.outerWidth(),
                minFrame = 0,
                maxFrame = self.frames - 1;

            self.xPosition = e.pageX;

            self.element.on('mousemove vmousemove', function (e) {
                if( !self.animating) {
                    self.animating =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){self.animateDraggedImage(e, containerOffset, containerWidth);}, 100)
                        : requestAnimationFrame(function(){self.animateDraggedImage(e, containerOffset, containerWidth);});
                }
            }).one('mouseup vmouseup', function (e) {
                self.slideShow.removeClass('cd-draggable');
                self.element.off('mousemove vmousemove');
                self.updateHandle();
            });

            e.preventDefault();

        }).on('mouseup vmouseup', function (e) {
            self.slideShow.removeClass('cd-draggable');
        });
    }

    productViewer.prototype.animateDraggedImage = function(e, containerOffset, containerWidth) {
        var self = this;
        var leftValue = self.xPosition - e.pageX;
        var widthValue = Math.ceil( (leftValue) * 100 / ( containerWidth * self.friction ));
        var frame = (widthValue * (self.frames-1))/100;
        if( frame > 0 ) {
            frame = Math.floor(frame);
        } else {
            frame = Math.ceil(frame);
        }
        var newFrame = self.visibleFrame + frame;

        if (newFrame < 0) {
            newFrame = self.frames - 1;
        } else if (newFrame > self.frames - 1) {
            newFrame = 0;
        }

        if( newFrame != self.visibleFrame ) {
            self.visibleFrame = newFrame;
            self.updateFrame();
            self.xPosition = e.pageX;
        }

        self.animating =  false;
    }

    productViewer.prototype.updateHandle = function() {
        if(this.handle) {
            var widthValue = 100*this.visibleFrame/this.frames;
            this.handle.animate({'left': widthValue + '%'}, 200);
        }
    }

    productViewer.prototype.updateFrame = function() {
        var transformValue = - (100 * this.visibleFrame/this.frames);
        transformElement(this.slideShow, 'translateX('+transformValue+'%)');
    }

    function transformElement(element, value) {
        element.css({
            '-moz-transform': value,
            '-webkit-transform': value,
            '-ms-transform': value,
            '-o-transform': value,
            'transform': value,
        });
    }

    var productToursWrapper = $('.cd-product-viewer-wrapper');
    productToursWrapper.each(function(){
        new productViewer($(this));
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main-legacy"]) return;
  try {
    
// append variant ID to window URL on option change
window.addEventListener('product-options:change-variant', (e) => {
  // update URL history with variant ID
  const url = new URL(window.location);
  url.searchParams.set('variant', e.detail.id);
  window.history.replaceState({}, '', url);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendations);

    const url = productRecommendations.dataset.url;

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendations.innerHTML = recommendations.innerHTML;
      }
  MiniCart.bindUIActions();
    })
    .catch(e => {
      console.error(e);
    });

  };

  const productRecommendations = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-secondary"]) return;
  try {
    
//
//
// ;(function ( w, doc, undefined ) {
// 	'use strict';
//
// 	/**
// 	 * Local object for method references
// 	 * and define script meta-data
// 	 */
// 	var ARIAaccordion = {};
// 	w.ARIAaccordion   = ARIAaccordion;
//
// 	ARIAaccordion.NS      = 'ARIAaccordion';
// 	ARIAaccordion.AUTHOR  = 'Scott O\'Hara';
// 	ARIAaccordion.VERSION = '3.2.1';
// 	ARIAaccordion.LICENSE = 'https://github.com/scottaohara/accessible_accordions/blob/master/LICENSE';
//
// 	var widgetClass   = 'accordion';
// 	var widgetTriggerClass = widgetClass + '__trigger';
// 	var widgetHeadingClass = widgetClass + '__heading';
// 	var widgetPanelClass = widgetClass + '__panel';
//
// 	var widgetHeading = '[data-aria-accordion-heading]';
// 	var widgetPanel   = '[data-aria-accordion-panel]'
//
// 	var idCounter = 0;
//
// 	/**
// 	 * Global Create
// 	 *
// 	 * This function validates that the minimum required markup
// 	 * is present to create the ARIA widget(s).
// 	 * Any additional markup elements or attributes that
// 	 * do not exist in the found required markup patterns
// 	 * will be generated via this function.
// 	 */
// 	ARIAaccordion.create = function () {
// 		var self;
// 		var panels;
// 		var defaultPanel = 'none';
// 		var headings;
// 		var triggers;
// 		var constantPanel;
// 		var multiPanel;
// 		var i;
//
// 		var widget = doc.querySelectorAll('[data-aria-accordion]');
//
// 		idCounter += 1;
//
// 		for ( i = 0; i < widget.length; i++ ) {
// 			self = widget[i];
// 			var t;
//
// 			/**
// 			 * Check for IDs and create arrays of necessary
// 			 * panels & headings for further setup functions.
// 			 */
// 			if ( !self.hasAttribute('id') ) {
// 				self.id = 'acc_' + idCounter + '-' + i;
// 			}
//
// 			/**
// 			 * Setup accordion classes
// 			 */
// 			self.classList.add(widgetClass);
//
//
// 			/**
// 			 * Get all panels & headings of an accordion pattern based
// 			 * on a specific ID > direct child selector (this will ensure
// 			 * that nested accordions don't get properties meant for
// 			 * the parent accordion, or vice-versa).
// 			 *
// 			 * If accordions are contained within an ol/ul, the selector
// 			 * needs to be different.
// 			 */
// 			if ( doc.querySelectorAll('#' + self.id + '> li').length ) {
// 				panels = doc.querySelectorAll('#' + self.id + ' li > ' + widgetPanel);
// 				headings = doc.querySelectorAll('#' + self.id + ' li > ' + widgetHeading);
// 			}
// 			else {
// 				panels = doc.querySelectorAll('#' + self.id + ' > ' + widgetPanel);
// 				headings = doc.querySelectorAll('#' + self.id + ' > ' + widgetHeading);
// 			}
//
// 			/**
// 			 * Check for options:
// 			 * data-default - is there a default opened panel?
// 			 * data-constant - should the accordion always have A panel open?
// 			 */
// 			if ( self.hasAttribute('data-default') ) {
// 				defaultPanel = self.getAttribute('data-default');
// 			}
//
// 			/**
// 			 * Accordions with a constantly open panel are not a default
// 			 * but if a data-constant attribute is used, then we need this
// 			 * to be true.
// 			 */
// 			constantPanel = self.hasAttribute('data-constant');
//
// 			/**
// 			 * Accordions can have multiple panels open at a time,
// 			 * if they have a data-multi attribute.
// 			 */
// 			multiPanel = self.hasAttribute('data-multi');
//
// 			/**
// 			 * If accordion panels are meant to transition, apply this inline style.
// 			 * This is to help mitigate a quick flash of CSS being applied to the
// 			 * no-js styling, and having an unwanted transition on initial page load.
// 			 */
// 			if ( self.hasAttribute('data-transition') ) {
// 				var thesePanels = self.querySelectorAll(widgetPanel);
//
// 				for ( t = 0; t < thesePanels.length; t++ ) {
// 					thesePanels[t].classList.add(widgetPanelClass + '--transition');
// 				}
// 			}
//
// 			/**
// 			 * Setup Panels, Headings & Buttons
// 			 */
// 			ARIAaccordion.setupPanels(self.id, panels, defaultPanel, constantPanel);
// 			ARIAaccordion.setupHeadingButton(headings, constantPanel);
//
// 			if ( doc.querySelectorAll('#' + self.id + '> li').length ) {
// 				triggers = doc.querySelectorAll('#' + self.id + ' li > ' + widgetHeading + ' .' + widgetTriggerClass);
// 			}
// 			else {
// 				triggers = doc.querySelectorAll('#' + self.id + ' > ' + widgetHeading + ' .' + widgetTriggerClass);
// 			}
//
// 			/**
// 			 * Now that the headings/triggers and panels are setup
// 			 * we can grab all the triggers and setup their functionality.
// 			 */
// 			for ( t = 0; t < triggers.length; t++ ) {
// 				triggers[t].addEventListener('click', ARIAaccordion.actions);
// 				triggers[t].addEventListener('keydown', ARIAaccordion.keytrolls);
// 			}
// 		} // for(widget.length)
// 	}; // ARIAaccordion.create()
//
//
// 	ARIAaccordion.setupPanels = function ( id, panels, defaultPanel, constantPanel ) {
// 		var i;
// 		var panel;
// 		var panelID;
// 		var setPanel;
// 		var constant;
//
// 		for ( i = 0; i < panels.length; i++ ) {
// 			panel = panels[i];
// 			panelID = id + '_panel_' + (i + 1);
// 			setPanel = defaultPanel;
// 			constant = constantPanel;
//
// 			panel.setAttribute('id', panelID);
// 			ariaHidden(panels[0], true);
//
// 			panel.classList.add(widgetPanelClass);
//
// 			/**
// 			 * Set the accordion to have the appropriately
// 			 * opened panel if a data-default value is set.
// 			 * If no value set, then no panels are open.
// 			 */
// 			if ( setPanel !== 'none' && parseInt(setPanel) !== NaN ) {
// 				// if value is 1 or less
// 				if ( setPanel <= 1 ) {
// 					ariaHidden(panels[0], false);
// 				}
// 				// if value is more than the number of panels, then open
// 				// the last panel by default
// 				else if ( (setPanel - 1) >= panels.length ) {
// 					ariaHidden(panels[panels.length - 1], false);
// 				}
// 				// for any other value between 2 - the last panel #, open that one
// 				else {
// 					ariaHidden(panels[(setPanel - 1)], false);
// 				}
// 			}
//
// 			/**
// 			 * If an accordion is meant to have a consistently open panel,
// 			 * and a default open panel was not set (or was not set correctly),
// 			 * then run one more check.
// 			 */
// 			if ( constant && setPanel === 'none' || parseInt(setPanel) === NaN ) {
// 				ariaHidden(panels[0], false);
// 			}
// 		}
// 	}; // ARIAaccordion.setupPanels
//
//
// 	ARIAaccordion.setupHeadingButton = function ( headings, constantPanel ) {
// 		var heading;
// 		var targetID;
// 		var targetState;
// 		var newButton;
// 		var buttonText;
// 		var i;
//
// 		for ( i = 0; i < headings.length; i++ ) {
// 			heading     = headings[i];
// 			targetID    = heading.nextElementSibling.id;
// 			targetState = doc.getElementById(targetID).getAttribute('aria-hidden');
//
// 			// setup new heading buttons
// 			newButton  = doc.createElement('button');
// 			buttonText = heading.textContent;
// 			// clear out the heading's content
// 			heading.innerHTML = '';
// 			// provide the heading with a class for styling
// 			heading.classList.add(widgetHeadingClass);
//
// 			newButton.setAttribute('type', 'button');
// 			newButton.setAttribute('aria-controls', targetID);
// 			newButton.setAttribute('id', targetID + '_trigger');
// 			newButton.classList.add(widgetTriggerClass);
//
// 			/**
// 			 * Check the corresponding panel to see if it was set up
// 			 * to be hidden or shown by default. Add an aria-expanded
// 			 * attribute value that is appropriate.
// 			 */
// 			if ( targetState === 'false' ) {
// 				ariaExpanded(newButton, true);
// 				isCurrent(newButton, true);
//
// 				/**
// 				 * Check to see if this an accordion that needs a constantly
// 				 * opened panel, and if the button's target is not hidden.
// 				 */
// 				if ( constantPanel ) {
// 					newButton.setAttribute('aria-disabled', 'true');
// 				}
// 			}
// 			else {
// 				ariaExpanded(newButton, false);
// 				isCurrent(newButton, false);
// 			}
//
// 			// Add the Button & previous heading text
// 			heading.appendChild(newButton);
// 			newButton.appendChild(doc.createTextNode(buttonText));
// 		}
// 	}; // ARIAaccordion.createButton
//
//
// 	ARIAaccordion.actions = function ( e ) {
// 		// Need to pass in if this is a multi accordion or not.
// 		// Also need to pass in existing trigger arrays.
// 		var thisAccordion = this.id.replace(/_panel.*$/g, '');
// 		var thisTarget = doc.getElementById(this.getAttribute('aria-controls'));
// 		var thisTriggers;
//
// 		if ( doc.querySelectorAll('#' + thisAccordion + '> li').length ) {
// 			thisTriggers = doc.querySelectorAll('#' + thisAccordion + ' li > ' + widgetHeading + ' .' + widgetTriggerClass);
// 		}
// 		else {
// 			thisTriggers = doc.querySelectorAll('#' + thisAccordion + ' > ' + widgetHeading + ' .' + widgetTriggerClass);
// 		}
//
// 		e.preventDefault();
//
// 		ARIAaccordion.togglePanel( e, thisAccordion, thisTarget, thisTriggers );
// 	}; // ARIAaccordion.actions()
//
//
// 	ARIAaccordion.togglePanel = function ( e, thisAccordion, targetPanel, triggers ) {
// 		var getID;
// 		var i;
// 		var thisTrigger = e.target;
//
// 		// check to see if a trigger is disabled
// 		if ( thisTrigger.getAttribute('aria-disabled') !== 'true' ) {
//
// 			getID = thisTrigger.getAttribute('aria-controls');
//
// 			isCurrent(thisTrigger, 'true');
//
// 			if ( thisTrigger.getAttribute('aria-expanded') === 'true' ) {
// 				ariaExpanded(thisTrigger, 'false');
// 				ariaHidden(targetPanel, 'true');
// 			}
// 			else {
// 				ariaExpanded(thisTrigger, 'true');
// 				ariaHidden(targetPanel, 'false');
//
// 				if ( doc.getElementById(thisAccordion).hasAttribute('data-constant') ) {
// 					ariaDisabled(thisTrigger, 'true');
// 				}
// 			}
//
// 			if ( doc.getElementById(thisAccordion).hasAttribute('data-constant') ||
// 					 !doc.getElementById(thisAccordion).hasAttribute('data-multi') ) {
//
// 				for ( i = 0; i < triggers.length; i++ ) {
// 					if ( thisTrigger !== triggers[i] ) {
// 						isCurrent(triggers[i], 'false');
// 						getID = triggers[i].getAttribute('aria-controls');
// 						ariaDisabled(triggers[i], 'false');
// 						ariaExpanded(triggers[i], 'false');
// 						ariaHidden(doc.getElementById(getID), 'true');
// 					}
// 				}
// 			}
// 		}
// 	};
//
//
// 	ARIAaccordion.keytrolls = function ( e ) {
// 		if ( e.target.classList.contains(widgetTriggerClass) ) {
// 			var keyCode = e.keyCode || e.which;
//
// 			// var keyUp = 38;
// 			// var keyDown = 40;
// 			var keyHome = 36;
// 			var keyEnd = 35;
//
// 			var thisAccordion = this.id.replace(/_panel.*$/g, '');
// 			var thisTriggers;
//
// 			if ( doc.querySelectorAll('#' + thisAccordion + '> li').length ) {
// 				thisTriggers = doc.querySelectorAll('#' + thisAccordion + ' li > ' + widgetHeading + ' .' + widgetTriggerClass);
// 			}
// 			else {
// 				thisTriggers = doc.querySelectorAll('#' + thisAccordion + ' > ' + widgetHeading + ' .' + widgetTriggerClass);
// 			}
//
//
// 			switch ( keyCode ) {
// 				/**
// 				 * keyUp & keyDown are optional controls
// 				 * for accordion components.
// 				 */
// 				// case keyUp:
// 				// 	if ( doc.getElementById(thisAccordion).hasAttribute('data-up-down') ) {
// 				// 		e.preventDefault();
// 				// 		// optional up arrow controls
// 				// 	}
// 				// 	break;
//
// 				// case keyDown:
// 				// 	if ( doc.getElementById(thisAccordion).hasAttribute('data-up-down') ) {
// 				// 		e.preventDefault();
// 				// 		// optional down arrow control
// 				// 	}
// 				// 	break;
//
// 				/**
// 				 * keyEnd/Home are optional functions that may not be inherently known
// 				 * to most users and, in the case of END, conflict with expected
// 				 * usage of that key with NVDA.
// 				 */
// 				case keyEnd:
// 					e.preventDefault();
// 					thisTriggers[thisTriggers.length - 1].focus();
// 					break;
//
// 				case keyHome:
// 					e.preventDefault();
// 					thisTriggers[0].focus();
// 					break;
//
// 				default:
// 					break;
// 			}
// 		}
// 	}; // ARIAaccordion.keytrolls()
//
//
// 	/**
// 	 * Initialize Accordion Functions
// 	 * if expanding this script, place any other
// 	 * initialize functions within here.
// 	 */
// 	ARIAaccordion.init = function () {
// 		ARIAaccordion.create();
// 	};
//
//
// 	/**
// 	 * Helper Functions
// 	 * Just to cut down on the verboseness of some declarations
// 	 */
// 	var ariaHidden = function ( el, state ) {
// 		el.setAttribute('aria-hidden', state);
// 	};
//
// 	var ariaExpanded = function ( el, state ) {
// 		el.setAttribute('aria-expanded', state);
// 	};
//
// 	var ariaDisabled = function ( el, state ) {
// 		el.setAttribute('aria-disabled', state);
// 	};
//
// 	var isCurrent = function ( el, state ) {
// 		el.setAttribute('data-current', state);
// 	};
//
// 	// go go JavaScript
// 	ARIAaccordion.init();
//
// })( window, document );


  } catch(e) { console.error(e); }
})();
})();
